// extracted by mini-css-extract-plugin
export default {"form":"ChangePasswordModal__form--2ewkF"};